import { Action } from '@ngrx/store';
import { Complaint } from '../../models/reception.model';
import { ServerDTO } from '../../models/app.model';


export const LOAD_ALL = '[Complaints] Load All';
export const LOAD_SUCCESS = '[Complaints] Load Success';
export const LOAD_FAIL = '[Complaints] Load Failed';
export const LOAD_ONE = '[Complaints] Load One';
export const LOAD_ONE_SUCCESS = '[Complaints] Load One Success';
export const LOAD_ONE_FAIL = '[Complaints] Load One Fail';
export const SET_COMPLAINT_YEAR = '[Complaints] Set Year';
export const SET_SELECTED_PAGE = '[Complaints] Set Selected Page';



export class LoadAll implements Action {
  readonly type = LOAD_ALL;
  constructor() { }
}

export class LoadSuccess implements Action {
  readonly type = LOAD_SUCCESS;
  constructor(public payload: ServerDTO) { }
}

export class LoadFail implements Action {
  readonly type = LOAD_FAIL;
  constructor(public payload: any) { }
}

export class LoadOne implements Action {
  readonly type = LOAD_ONE;
  constructor(public payload: string) { }
}

export class LoadOneSuccess implements Action {
  readonly type = LOAD_ONE_SUCCESS;
  constructor(public payload: Complaint) { }
}

export class LoadOneFail implements Action {
  readonly type = LOAD_ONE_FAIL;
  constructor(public payload: any) { }
}

export class SetComplaintYear implements Action {
  readonly type = SET_COMPLAINT_YEAR;
  constructor(public payload: string) { }
}

export class SetSelectedPage implements Action {
  readonly type = SET_SELECTED_PAGE;
  constructor(public payload: number) { }
}

export type ComplaintAction = LoadAll | LoadSuccess | LoadFail | LoadOne
  | LoadOneSuccess | LoadOneFail | SetComplaintYear | SetSelectedPage;
